<template>
    <div class="client-message">
        <div class="client-content">
            {{ message }}
        </div>
        <div class="client-time">
            {{ time }}
        </div>
    </div>
</template>
<script>
export default {
    props: {
        content: Object
    },
    computed: {
        message: {
            get() {
                return this.content.message
            }
        },
        time: {
            get() {
                return this.content.time
            }
        }
    }
}
</script>
<style lang="scss">
    .client-message {
        display: inline-block;
        background-color: #4A148C;
        border-radius: 7px 7px 0px 7px;
        float: right;
        
        .client-content {
            padding: 5px;
            margin: 5px;
            color: white;
        }

        .client-time {
            color: #FAFAFA;
            text-align: right;
            font-size: 9px;
            margin: 0px 10px 5px 10px;
        }
    }
    
</style>